module.exports = __webpack_public_path__ + "static/media/radioactive-materials-waste-add.07e3babb.svg";